import Butter from "buttercms";

const butter = Butter("bd76356ad261a2c45a957a9b773f53e569443648");

export default butter;
